import { Component, inject } from "@angular/core";
import {
  RdxDialogContentDirective,
  RdxDialogTitleDirective,
  RdxDialogDescriptionDirective,
  RdxDialogCloseDirective,
} from "@radix-ng/primitives/dialog";
import { SequenceService } from "@services/sequence.service";

@Component({
  selector: "app-sequence-completion-modal",
  standalone: true,
  imports: [RdxDialogContentDirective, RdxDialogTitleDirective, RdxDialogDescriptionDirective, RdxDialogCloseDirective],
  template: `
    <div
      class="modal modal-medium"
      data-testid="sequence-completion-modal"
      role="alertdialog"
      aria-labelledby="sequence-completion-modal-title"
      aria-describedby="sequence-completion-modal-description"
      rdxDialogContent
    >
      <div class="modal-content sequence-completion-modal__content">
        @if (this.sequenceService.isInReworkErrorsMode() && !this.sequenceService.hasIncorrectAnswers()) {
          <div class="sequence-completion-modal__message">
            <h3 id="sequence-completion-modal-title" class="title-h3" rdxDialogTitle>Bravo!</h3>
            <p id="sequence-completion-modal-description" class="body-2" rdxDialogDescription>Tu as fini de retravailler tes erreurs!</p>
          </div>
          <img class="sequence-completion-modal__flo" src="assets/flo/flo-baguette-magique.svg" alt="Flo Baguette Magique" />
        } @else {
          <div class="sequence-completion-modal__message">
            <h3 id="sequence-completion-modal-title" class="title-h3" rdxAlertDialogTitle>Bravo!</h3>
            <p id="sequence-completion-modal-description" class="body-2">Tu as complété une série d'exercices!</p>
          </div>
          <img class="sequence-completion-modal__flo" src="assets/flo/flo-peace.svg" alt="Flo peace" />
        }
      </div>
      <div class="modal-actions">
        <button class="btn btn-secondary" (click)="handleShowResults()" rdxDialogClose>Voir mes résultats</button>
        @if (sequenceService.hasIncorrectAnswers()) {
          <button class="btn btn-primary" (click)="handleReworkErrors()" rdxDialogClose>Retravailler mes erreurs</button>
        }
      </div>
    </div>
  `,
  styles: `
    @use "responsive" as *;

    .sequence-completion-modal__content {
      position: relative;
      padding-bottom: 0;
      @include screenWidth("to-mobile-small") {
        padding-top: 100px;
      }
    }

    .sequence-completion-modal__flo {
      display: block;
      width: 100%;
      max-width: 311px;
      margin: 8px auto 0 auto;
    }

    .sequence-completion-modal__message {
      position: absolute;
      right: 0;
      left: 0;
      margin: 0 auto;
      text-align: center;
      > * {
        text-align: center;
      }
    }
  `,
})
export class SequenceCompletionModal {
  protected sequenceService = inject(SequenceService);

  protected handleReworkErrors() {
    this.sequenceService.goToReworkErrorsMode();
  }

  protected handleShowResults() {
    this.sequenceService.completeSequence();
  }
}
